import { faGhost, faPause } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  ArrowRightIcon,
  ArrowRightToLineIcon,
  FlexBox,
  JoonUIColor,
  SPACING,
  TextButton,
  Typography,
} from "@joonapp/web-shared"

import useCurrentClient from "./hooks/useCurrentClient"
import useCoachingGroup from "../../hooks/useCoachingGroup"
import useMobile from "../../hooks/useMobile"
import ClientTabNav from "../../pages/clients/ClientTabNav"
import useInfoPanelStore from "../../pages/home/store/useInfoPanelStore"
import { SendBirdView } from "../../pages/home/store/useMobileViewStore"
import useMobileViewStore from "../../pages/home/store/useMobileViewStore"

const ClientPageHeader = () => {
  const { setView } = useMobileViewStore()
  const isMobile = useMobile()
  const { currentCoachingGroup } = useCurrentClient()
  const { isInactive, isPaused, subscriptionResumeDate } =
    useCoachingGroup(currentCoachingGroup)

  const { isOpen: isOpenInfoPanel, togglePanel } = useInfoPanelStore()
  const { currentClientProfile } = useCurrentClient()

  const onClickBack = () => {
    setView(SendBirdView.CHANNEL_LIST)
  }

  if (!currentClientProfile) return <></>

  return (
    <FlexBox
      direction="column"
      gap={SPACING.space2}
      wrap={false}
      style={{
        padding: `${SPACING.space4} ${SPACING.space6} ${SPACING.space0}`,
        borderBottom: `1px solid ${JoonUIColor.border.default}`,
      }}
    >
      <FlexBox direction="row" align="center" gap={SPACING.space2} wrap={false}>
        {isMobile && (
          <button style={{ transform: "rotate(180deg)" }} onClick={onClickBack}>
            <ArrowRightIcon color={JoonUIColor.icon.neutral} size={20} />
          </button>
        )}
        <Typography variant="h2">
          {currentClientProfile.user.name}{" "}
          {currentClientProfile.user.last_name
            ? currentClientProfile.user.last_name
            : ""}
        </Typography>
        {isPaused ? (
          <div className="flex px-2 py-1 bg-red-400 rounded-md gap-2 items-center">
            <FontAwesomeIcon icon={faPause} color={JoonUIColor.icon.inverted} />
            <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
              Paused until {subscriptionResumeDate}
            </Typography>
          </div>
        ) : (
          isInactive && (
            <div className="flex px-2 py-1 bg-red-400 rounded-md gap-2 items-center">
              <FontAwesomeIcon
                icon={faGhost}
                color={JoonUIColor.icon.inverted}
              />
              <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
                Inactive
              </Typography>
            </div>
          )
        )}
        {!isMobile && (
          <TextButton
            onClick={togglePanel}
            style={{
              transform: isOpenInfoPanel ? "rotate(0deg)" : "rotate(180deg)",
              marginLeft: "auto",
            }}
          >
            <ArrowRightToLineIcon />
          </TextButton>
        )}
      </FlexBox>
      <ClientTabNav />
    </FlexBox>
  )
}

export default ClientPageHeader
